// src/components/ui/InPageNav.js
import React, { useState, useEffect } from 'react';

const InPageNav = () => {
  const [activeSection, setActiveSection] = useState('overview');

  const sections = [
    { id: 'overview', label: 'Overview' },
    { id: 'discovery', label: 'Discovery' },
    { id: 'define', label: 'Define' },
    { id: 'ideation', label: 'Ideation' },
    { id: 'solution', label: 'Solution' },
    { id: 'test-iterations', label: 'Test & Iterations' },
    { id: 'outcome', label: 'The Outcome' },
    { id: 'moving-forward', label: 'Moving Forward' },
    { id: 'reflection', label: 'System thinking in action' }
  ];

  // Handle scroll to update active section
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200; // Offset for better UX

      for (let i = sections.length - 1; i >= 0; i--) {
        const element = document.getElementById(sections[i].id);
        if (element && element.offsetTop <= scrollPosition) {
          setActiveSection(sections[i].id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className="fixed right-4 lg:right-8 top-1/2 transform -translate-y-1/2 hidden lg:block z-40">
      <ul className="space-y-2 lg:space-y-3">
        {sections.map((section) => (
          <li key={section.id}>
            <a
              href={`#${section.id}`}
              onClick={(e) => handleClick(e, section.id)}
              className={`text-xs lg:text-sm transition-all duration-200 block ${
                activeSection === section.id
                  ? 'text-primary font-semibold'
                  : 'text-gray-500 hover:text-gray-800'
              }`}
            >
              {section.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default InPageNav;